<template>
  <simple-scrollable-modal>
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        item-key="name"
      ></v-data-table>
    </template>
    <template #action-bar>
      <v-btn text @click="$emit('close')">Debo hacer cambios</v-btn>
      <v-btn color="success" @click="confirm">Me parece correcto</v-btn>
    </template>
  </simple-scrollable-modal>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
  import readXlsxFile from 'read-excel-file';
  import SimpleScrollableModal from './base/SimpleScrollableModal.vue';
  import { xlsToItems } from '../../lib/XlsToItems';
  Vue.use(VuetifyDraggableTreeview);

  @Component({
    components: { SimpleScrollableModal },
  })
  export default class UploadMenuPreviewModal extends Vue {
    @Prop() title: string;
    @Prop() message: string;
    @Prop() rows: (string | number)[][];
    @Prop() startRow: number;
    @Prop() column;
    items = [];
    headers = [
      { text: 'Nombre', align: 'start', value: 'name' },
      { text: 'Descripción', value: 'description' },
      { text: 'Precio', value: 'price' },
      { text: 'Categoría', value: 'category' },
    ];

    async created() {
      this.items = xlsToItems(this.rows, this.column, this.startRow);
    }

    confirm() {
      this.$parent.$emit('confirm');
      this.$emit('close');
    }
  }
</script>
